var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 38,
    viewBox: "0 0 276 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22292 34.8333L11.7958 23.7104L3.16667 16.2292L14.5667 15.2396L19 4.75L23.4333 15.2396L34.8333 16.2292L26.2042 23.7104L28.7771 34.8333L19 28.9354L9.22292 34.8333Z",
    fill: "#FFC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9802 34.8333L71.4854 23.7104L63.0833 16.2292L74.1833 15.2396L78.5 4.75L82.8167 15.2396L93.9167 16.2292L85.5146 23.7104L88.0198 34.8333L78.5 28.9354L68.9802 34.8333Z",
    fill: "#FFC200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.223 34.8333L130.796 23.7104L122.167 16.2292L133.567 15.2396L138 4.75L142.433 15.2396L153.833 16.2292L145.204 23.7104L147.777 34.8333L138 28.9354L128.223 34.8333Z",
    fill: "#FFC200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.98 34.8333L190.485 23.7104L182.083 16.2292L193.183 15.2396L197.5 4.75L201.817 15.2396L212.917 16.2292L204.515 23.7104L207.02 34.8333L197.5 28.9354L187.98 34.8333Z",
    fill: "#FFC200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.223 34.8333L249.796 23.7104L241.167 16.2292L252.567 15.2396L257 4.75L261.433 15.2396L272.833 16.2292L264.204 23.7104L266.777 34.8333L257 28.9354L247.223 34.8333Z",
    fill: "#FFC200"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.edcb06a23372dd3fe80afceda8af6fb3.svg";
export { ForwardRef as ReactComponent };